import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'ui';

const BackArrow = ({ onClick, color, backIcon, size }) => {
  return (
    <div className="back-button" onClick={onClick}>
      <Icon name={backIcon ? 'arrow-back' : 'arrow-left'} size={size || 'big'} color={color} />
    </div>
  );
};

BackArrow.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.string,
  backIcon: PropTypes.bool,
  size: PropTypes.string,
};

BackArrow.defaultProps = {
  onClick: function () {},
  color: 'default',
  backIcon: false,
  size: 'big',
};

export default BackArrow;
